// extracted by mini-css-extract-plugin
export default {"Root":"Switch_Root__DiJgb","Switch":"Switch_Switch__7ztkn","Checked":"Switch_Checked__CT4Zu","Disabled":"Switch_Disabled__ytoQL"};